import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import {AdminLayout, Scroller} from 'components/elements'
import SectionContent from 'components/elements/SectionContent'
import {accountActions, insightsActions} from 'actions'
import moment from 'moment'
import {NotesWidget} from 'components/partials'

class Dashboard extends React.Component {
  componentDidMount(){
    insightsActions.fetch()
  }
  render() {
    return (
      <AdminLayout>
        <SectionContent>
          <h1>Dashboard</h1>
          <Scroller>
            <div>
              {accountActions.isSuperAdministrator() && (
                <Fragment>
                  <Row>
                    <Col xs={8}>
                      <h3>Total Appointments:</h3>
                      {_.get(this, 'props.insights.appointments.all', []).map(({date, total})=>(
                        <div>{moment(date, 'YY-MM-DD').format('MM-DD')} {total}</div>
                      ))}
                    </Col>
                    <Col xs={8}>
                      <h3>Appointments Booked in Widget:</h3>
                      {_.get(this, 'props.insights.appointments.createdByUser', []).map(({date, total})=>(
                        <div>{moment(date, 'YY-MM-DD').format('MM-DD')} {total}</div>
                      ))}
                    </Col>
                    <Col xs={8}>
                      <h3>Appointments Created in PIM:</h3>
                      {_.get(this, 'props.insights.appointments.createdByAdministrator', []).map(({date, total})=>(
                        <div>{moment(date, 'YY-MM-DD').format('MM-DD')} {total}</div>
                      ))}
                    </Col>
                  </Row>
                </Fragment>
              )}
            </div>
          </Scroller>
        </SectionContent>
      </AdminLayout>
    )
  }
}

export default connect((state)=>({insights: state.insights}))(Dashboard)



// WEBPACK FOOTER //
// ./src/components/templates/Dashboard.jsx